import { WebPNextImage } from '@/components/WebPImage';
import Image from 'next/image';

const radiusTrendUp = '/img/products/vod-assessment/rediusTrendup.webp';
const radiusTrendDown = '/img/products/vod-assessment/radiusTrendDown.webp';

interface IProps {
  type?: 'down' | 'up' | '';
}

const RadiusTrendImg = ({ type }: IProps) => {
  const imgSrc = type === 'down' ? radiusTrendDown : radiusTrendUp;
  return (
    type && (
      <span style={{ padding: '0 5px' }}>
        <WebPNextImage
          alt={type}
          height="10"
          width="10"
          src={imgSrc}
          crossOrigin="anonymous"
        />
      </span>
    )
  );
};

export default RadiusTrendImg;
